const doc = [({"da":({"js":({"admin":({"roles":({"edit":({"the_role_was_saved":"Rollen blev gemt", "edit_role":"Rediger rolle: %{role_name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;